import { render, staticRenderFns } from "./cart-info.vue?vue&type=template&id=0c5927a6&"
import script from "./cart-info.vue?vue&type=script&lang=js&"
export * from "./cart-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports